import { ImportLoadsStatus } from '../import-loads-status';
import { ImportFileLoadRowResult } from './import-file-load-row-result';
import { ImportFileLoadsColumn } from './import-file-loads-column';

export class ImportFileLoadsResult {

  public status: ImportLoadsStatus;
  public reason: ImportFileLoadsResultReason;
  public result: any[];
  public rows: ImportFileLoadRowResult[];
  public columns: ImportFileLoadsColumn[];
  public missingColumns: ImportFileLoadsColumn[];
  public unexpectedColumns: { name: string, position: number }[];

  static fromDto(data: any): ImportFileLoadsResult {
    if (!data) {
      return null;
    }

    const importResult = new ImportFileLoadsResult();

    let rows: ImportFileLoadRowResult[]         = [];
    let columns: ImportFileLoadsColumn[]        = [];
    let missingColumns: ImportFileLoadsColumn[] = [];

    importResult.status            = data.status;
    importResult.reason            = data.reason;
    importResult.result            = data.result || [];
    importResult.unexpectedColumns = data.unexpected_columns || [];

    if (data.rows) {
      rows = data.rows.map(r => ImportFileLoadRowResult.fromDto(r, importResult.unexpectedColumns));
    }

    if (data.columns) {
      columns = data.columns.map(c => ImportFileLoadsColumn.fromDto(c));
    }

    if (data.missing_columns) {
      missingColumns = data.missing_columns.map(c => ImportFileLoadsColumn.fromDto(c));
    }

    importResult.rows           = rows;
    importResult.columns        = columns;
    importResult.missingColumns = missingColumns;

    return importResult;
  }
}

export enum ImportFileLoadsResultReason {
  EMPTY_FILE                       = 'EMPTY_FILE',
  EMPTY_ROWS                       = 'EMPTY_ROWS',
  COULD_NOT_EXTRACT_HEADER_COLUMNS = 'COULD_NOT_EXTRACT_HEADER_COLUMNS',
  INVALID_HEADER_COLUMNS           = 'INVALID_HEADER_COLUMNS',
  PARSING_ERROR                    = 'PARSING_ERROR',
  VALIDATION_ERROR                 = 'VALIDATION_ERROR',
  IMPORT_ERROR                     = 'IMPORT_ERROR'
}
